<template>
    <b-modal
        id="roadmap-title-edit-modal"
        :title="$t('roadmap.edit_title')"
        :ok-title="$t('common.save')"
        :cancel-title="$t('common.cancel')"
        cancel-variant="outline-primary"
        :ok-disabled="!title"
        size="md"
        @ok="onOk()"
        @show="onShow()"
        modal-class="apprentice-default-modal">
        <div class="update-roadmap-title">
            <b-form-group
                :label="$t('common.name')"
                label-for="roadmap-title-input">
                <b-form-input
                    id="roadmap-title-input"
                    v-model="title"
                    :placeholder="$t('roadmap.type_title_here')">
                </b-form-input>
            </b-form-group>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-roadmap-edit-title-modal-component',
    props: ['roadmapIn'],
    data() {
        return {
            title: this.roadmapIn.title,
        };
    },
    methods: {
        onShow() {
            this.title = this.roadmapIn.title;
        },

        onOk() {
            this.alert.saving();

            const data = {
                roadmap_id: this.roadmapIn.id,
                title: this.title,
            };

            this.axios.post(this.routes.roadmapUpdateTitle(), data).then(
                (response) => {
                    this.roadmapIn.update({ title: this.title });

                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style></style>
